import React, { useEffect, useState } from "react";
import {
  CardProps,
  DataFormRol,
  MenuItem,
  typeAlert,
  variantsAvatar,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import LocalStorageService from "../../services/localStorage";
import { menuItem, selectValueDefault } from "./resource/data";
import { PermisionView } from "./view";
import showToast from "../../services/toast";

import {
  ColumnsPermissions,
  rolDataForm,
  RolPermission,
} from "./resource/data.Dto";
import { usePermissionGetAll } from "../../fnx/permission/permissionGetAll";
import { RowsModel } from "../../model/insurancePoliciesSummary";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import { Permission } from "../../model/permission";
import { permissionClearData } from "../../store/permissions/actions";

const storageKey2 = "afy-login";
const lsLogin = new LocalStorageService(storageKey2);
export const PermissionAdmin = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [triggerPermission, setTriggerPermission] = useState<boolean>(false);

  const [permissionList, setPermissionList] = useState<CardProps[]>([]);

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
  const [openModalDeletePermission, setOpenModalDeletePermission] =
    useState<boolean>(false);

  const [pageCatalog, setPageCatalog] = useState<number>(1);
  const [limitCatalog, setLimitCatalog] = useState<number>(20);
  const [countPag, setCountPag] = useState<number>(0);

  // const [permissionList, setPermissionList] = useState([]);
  const [permissionL, setPermissionL] = useState([]);

  const [clientId] = React.useState<string>(
    lsLogin.getUserLoginStored().clientId,
  );
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [openDrawerPermission, setOpenDrawerPermission] =
    useState<boolean>(false);
  const [itemModal, setItemModal] = useState<any>(null);
  const [nameSearch, setNameSearch] = useState<string>("");
  // const [bodyRequest, setBodyRequest] = useState<RolRequest>();
  const [dataForm, setDataForm] = useState<DataFormRol>(rolDataForm);
  const [seeToast, setSeeToast] = useState<{
    show: boolean;
    type: typeAlert;
    message: string;
  }>({
    show: false,
    message: "",
    type: typeAlert.success,
  });

  const [titleDelete, setTitleDelete] = React.useState("");
  const [subTitleDelete, setSubTitleDelete] = React.useState("");
  const [permissionId, setPermissionId] = React.useState("");

  /*Llamada al getAll para recuperar todos los permisos*/
  const { responsePermission, errorPermission, loadingPermission } =
    usePermissionGetAll(
      triggerPermission,
      clientId,
      pageCatalog,
      limitCatalog,
      nameSearch,
    );

  /*Llamada al POST */

  /*Llamada al Patch*/

  /*Llamada al Disable*/

  const clickContextMenuPaymentMode = (item: RowsModel) => {
    setOpenModalDeletePermission(true);
    setTitleDelete("Permisos");
    setSubTitleDelete(`el permiso ${item.description?.toLowerCase()}`);
    setPermissionId(item.id ? item.id : "");
    setIsUpdate(true);
    // showEdit(item);

    /*Unifica listas quita duplicados y actualiza */
    const listPermissionDb: string[] = itemModal.permission.map(
      (rol: RolPermission) => rol.id,
    );

    //Quita el ID que deseo de la lista
    const updatedListPermissionDb = listPermissionDb.filter(
      (id) => id !== item.id,
    );

    //Actualiza la nueva lista de Permisos
    // setBodyRequest({
    //   id: itemModal.id,
    //   clientId: itemModal.clientId,
    //   RolName: itemModal.code,
    //   RolDescription: itemModal.type,
    //   Permissions: updatedListPermissionDb,
    // });
    setOpenDrawerPermission(false);
    setOpenModal(false);
  };

  const columnsPermissions = ColumnsPermissions(clickContextMenuPaymentMode);

  const callPermission = () => {
    setTriggerPermission(!triggerPermission);
  };

  /*habilita trigger para getAll api de Permisos*/
  useEffect(() => {
    callPermission();
  }, []);

  /*Valida respuesta del getAll y mapea objetos*/
  useEffect(() => {
    if (responsePermission && responsePermission?.data.length > 0) {
      const listPermission: CardProps[] = responsePermission?.data.map(
        (item: Permission) => ({
          id: item.id,
          type: item.type,
          title: item.name,
        }),
      );
      setPermissionList(listPermission);
      setTriggerPermission(false);

      const lPermission = responsePermission?.data.map((item: Permission) => ({
        id: item.id,
        description: item.description,
        name: item.name,
        type: item.type,
        enabled: item.enabled ? "Activo" : "Inactivo",
      }));

      setPermissionL(lPermission);

      if (responsePermission?.pagingInfo) {
        setCountPag(responsePermission?.pagingInfo.totalItems);
      }

      dispatch(permissionClearData());
    } else if (responsePermission && responsePermission?.length === 0) {
      setTriggerPermission(false);
      setPermissionList([]);
    }
  }, [responsePermission]);

  /*Valida respuesta de la creacion del ROL*/

  /*Valida respuesta del update del ROL*/

  /*Valida respuesta del disable del ROL*/

  const onClickClearData = (Data: any) => {
    // Valida clean filtro y limpia los filtros
    if (Data.filter.type_filter === "empty") {
      // setValueDescription(undefined);
      // setValueName(undefined);
    }
    // Llama a la consulta general sin filtros
    callPermission();
  };

  /*Mapea los filtros para enviarlos al API para busqueda*/
  const onClickApplyFilter = (Data: any) => {
    if (Data.filter.type_filter === "name") {
      // setValueName(Data.filter.filter_value);
      // setValueDescription(undefined);
    } else if (Data.filter.type_filter === "description") {
      // setValueDescription(Data.filter.filter_value);
      // setValueName(undefined);
    }
    callPermission();
  };

  const searchFilter = (term: string) => {
    console.log(term);
    if (term.length > 3) {
      setNameSearch(term);
      setTriggerPermission(true);
    } else if (term.length === 0) {
      setNameSearch("");
      setTriggerPermission(true);
    }
  };

  const newItem = () => {
    setDataForm({
      id: "",
      clientId: "",
      RolName: "",
      RolDescription: "",
    });
  };

  const onCloseSearch = () => {
    setNameSearch("");
    setTriggerPermission(true);
  };

  const handleOnClickAdd = () => {
    newItem();
    setIsUpdate(false);
    setOpenDrawerPermission(true);
  };

  /*Mapea el objeto para enviar en el POST*/
  const handleSubmitPermission = (dataRol: any) => {
    if (isUpdate) {
      // setBodyRequest({
      //   id: dataRol.id,
      //   clientId: dataRol.clientId,
      //   RolName: dataRol.RolName,
      //   RolDescription: dataRol.RolDescription,
      // });
      // setTriggerPatch(true);
      setOpenDrawerPermission(false);
    } else {
      // setBodyRequest({
      //   RolName: dataRol.RolName,
      //   RolDescription: dataRol.RolDescription,
      // });
      // setDataForm(rolDataForm);
      setOpenDrawerPermission(false);
      // setTriggerPost(true);
    }
    setOpenModal(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const onClickContextMenu = (opt?: any, item?: any) => {
    switch (opt.id) {
      case "1":
        setIsUpdate(true);
        setOpenDrawerPermission(true);
        // showEdit(item);
        break;
      case "2":
        setOpenModalDelete(true);
        setItemModal(item);
        break;
      case "3":
        // const listPermissionDb: RolPermission[] = item.permission?.map(
        //   (item: RolPermission) => ({
        //     id: item.id,
        //     name: item.name,
        //     description: item.description,
        //   }),
        // );

        setItemModal(item);
        setIsUpdate(true);
        // showEdit(item);
        setOpenDrawerPermission(true);
        break;
    }
  };

  const clickView = (view: MenuItem) => {
    setItemModal(view);
  };

  const onCloseDrawerPermissions = () => {
    setOpenDrawerPermission(false);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleDelete = () => {
    setOpenModalDelete(false);
    // setTriggerDisable(true);
  };
  const handleDeletePermission = () => {
    setOpenModalDeletePermission(false);
    // setTriggerPatch(true);
  };

  const onChangePage = (e: number) => {
    setPageCatalog(e);
    setTriggerPermission(true);
  };

  const onChangeRowsPerPage = (e: number) => {
    setLimitCatalog(e);
    setTriggerPermission(true);
  };

  return (
    <React.Fragment>
      <AlertLoadingHeader
        loading={loadingPermission}
        seeToast={seeToast}
        showToast={showToast}
        setSeeToast={setSeeToast}
        titleLoading={"Cargando roles..."}
      />

      <PermisionView
        title={"Permiso"}
        titleDrawer={isUpdate ? "Modificar Permiso" : "Agregar Permiso"}
        list={permissionList}
        avatarVariant={variantsAvatar.rounded}
        openModal={openModal}
        onSaveData={handleSubmitPermission}
        // dataForm={permissionList}
        modalTitle={itemModal?.title}
        editMode={isUpdate}
        clickView={clickView}
        onSubmit={handleDelete}
        onClose={handleCloseModal}
        onCloseSearch={onCloseSearch}
        openDrawer={openDrawerPermission}
        setOpenDrawer={setOpenDrawerPermission}
        openModalDelete={openModalDelete}
        setOpenModalDelete={setOpenModalDelete}
        onCloseDrawer={onCloseDrawerPermissions}
        searchFilter={searchFilter}
        handleOpenModal={handleOpenModal}
        onClickContextMenu={onClickContextMenu}
        onClickAdd={handleOnClickAdd}
        onClickCancel={handleCloseModal}
        onFilterApply={onClickApplyFilter}
        onFilterEmpty={onClickClearData}
        selectValueDefault={selectValueDefault}
        menuItem={menuItem}
        //View List
        columnsPermissions={columnsPermissions}
        rowsPermissions={permissionL}
        countPagination={countPag}
        limitCatalog={limitCatalog}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        pageCatalog={pageCatalog}
      />
    </React.Fragment>
  );
};